import { Video, CheckCircle, XCircle, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';

export const AdminCreatorsTab = () => {
  const { contentCreatorRegistrations, apiCall } = useAdmin();

  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Content Creator Registrations ({contentCreatorRegistrations.length})</h2>
      {contentCreatorRegistrations.length === 0 ? (
        <Card className="bg-card border-border">
          <CardContent className="py-12 text-center">
            <Video size={48} className="mx-auto text-muted-foreground mb-4" />
            <h3 className="text-lg font-semibold mb-2">No registrations yet</h3>
            <p className="text-muted-foreground">Content creator registration requests will appear here.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {contentCreatorRegistrations.map(creator => (
            <Card key={creator.id} className={`bg-card border-border ${creator.status === 'pending' ? 'border-yellow-500/50' : ''}`}>
              <CardHeader className="pb-2">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg">{creator.creator_name}</CardTitle>
                  <Badge className={creator.status === 'pending' ? 'bg-yellow-500/20 text-yellow-500' : creator.status === 'approved' ? 'bg-green-500/20 text-green-500' : 'bg-red-500/20 text-red-500'}>{creator.status}</Badge>
                </div>
                <CardDescription>{creator.contact_name} - {creator.email}</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-2 text-sm mb-3">
                  <p><strong>Type:</strong> {creator.content_type}</p>
                  <p><strong>Experience:</strong> {creator.years_experience ? `${creator.years_experience} years` : 'Not specified'}</p>
                  {creator.specialties && <p><strong>Specialties:</strong> {creator.specialties}</p>}
                  <p className="text-muted-foreground line-clamp-2">{creator.description}</p>
                  {creator.youtube && <p><strong>YouTube:</strong> <a href={creator.youtube} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">{creator.youtube}</a></p>}
                  {creator.instagram && <p><strong>Instagram:</strong> {creator.instagram}</p>}
                  {creator.portfolio_url && <p><strong>Portfolio:</strong> <a href={creator.portfolio_url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">View Portfolio</a></p>}
                </div>
                {creator.status === 'pending' && (
                  <div className="flex gap-2">
                    <Button size="sm" className="flex-1" onClick={() => apiCall('put', `/admin/content-creator-registrations/${creator.id}?status=approved`)}><CheckCircle size={14} className="mr-1" /> Approve</Button>
                    <Button size="sm" variant="destructive" className="flex-1" onClick={() => apiCall('put', `/admin/content-creator-registrations/${creator.id}?status=rejected`)}><XCircle size={14} className="mr-1" /> Reject</Button>
                  </div>
                )}
                {creator.status === 'approved' && <Badge className="bg-green-500/20 text-green-500">Verified Creator</Badge>}
                <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-2" onClick={() => apiCall('delete', `/admin/content-creator-registrations/${creator.id}`)}><Trash2 size={12} className="mr-1" /> Delete</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </>
  );
};
